import React, { useCallback, useState } from 'react'

import { LeanMenuFragment } from '~/generated/graphql'
import Tooltip from '~/shared/atoms/Tooltip'
import { RestaurantMenusView } from '~/shared/molecules/RestaurantMenu'

import { CloseIcon } from '../CloseIcon'

import { MenuIcon, MenuIconWrapper, TooltipWrapper } from './RestaurantMenuTooltipShards'

export function RestaurantMenuTooltipView({
  menus,
  forceLabels,
  showMenuValue = true,
  style,
  onMouseEnter,
  iconSize = '1rem',
}: {
  style?: React.CSSProperties
  menus: LeanMenuFragment[]
  forceLabels: boolean
  showMenuValue?: string | boolean
  onMouseEnter?: () => void
  iconSize?: string
}) {
  const [showMenuModal, setShowMenuModal] = useState<string | boolean>(false)

  const handleMouseEnter = useCallback(() => {
    setShowMenuModal(showMenuValue)
    onMouseEnter?.()
  }, [onMouseEnter, showMenuValue])

  return (
    <TooltipWrapper
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => {
        setShowMenuModal(false)
      }}
      onClick={e => {
        setShowMenuModal(showMenuValue)
        e.stopPropagation()
      }}
      style={style}>
      <Tooltip
        size={'big'}
        placement={'auto'}
        show={showMenuModal === showMenuValue}
        label={
          <>
            <CloseIcon
              onClick={e => {
                e.stopPropagation()
                setShowMenuModal(false)
              }}
            />
            <RestaurantMenusView menus={menus} forceLabels={forceLabels} />
          </>
        }
        trigger={'programmatic'}>
        <MenuIconWrapper onClick={e => e.preventDefault()} iconSize={iconSize}>
          <MenuIcon icon='book-new' iconSize={iconSize} />
        </MenuIconWrapper>
      </Tooltip>
    </TooltipWrapper>
  )
}
